import React from "react";
import { MEDIA_URL } from "../../config/url";
import { useNavigate } from "react-router-dom";

const PopularCities = ({ popularcitytable }) => {
  const navigate = useNavigate();
  return (
    <>
      <section className="layout-pt-sm layout-pb-md bg-light-4">
        <div className="container">
          <div className="row y-gap-20 justify-center text-center">
            <div className="col-auto">
              <div className="sectionTitle -md">
                <h2 className="sectionTitle__title text-primary">
                  Discover Events In Your Popular City
                </h2>
              </div>
            </div>
          </div>
          <div className="row y-gap-30 pt-20 justify-between">
            {popularcitytable?.map((rowdatacity) => {
              return (
                <div
                  className="w-1/5 lg:w-1/3 sm:w-1/2"
                  key={rowdatacity.City_Id}
                  onClick={() => {
                    localStorage.setItem(
                      "navigateSelectedCity",
                      rowdatacity?.City_Name
                    );
                    navigate("event/list");
                  }}
                >
                  <div className="citiesCard -type-2 ">
                    <div className="citiesCard__image rounded-8 ratio ratio-2:1">
                      <img
                        className="img-ratio rounded-4 js-lazy"
                        data-src={`${MEDIA_URL}${rowdatacity.Image_Path}`}
                        src={`${MEDIA_URL}${rowdatacity.Image_Path}`}
                        alt={rowdatacity.City_Name}
                      />
                    </div>
                    <div className="citiesCard__content d-flex items-center justify-center">
                      <div>
                        <h4 className="text-16 uppercase lh-13 fw-500 text-white text-center">
                          {rowdatacity.City_Name}
                        </h4>
                        <p className="fw-500 text-12 text-white cityCount text-center">
                          {rowdatacity?.Events_Counts} EVENTS
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>
    </>
  );
};

export default PopularCities;
